import { useCallback } from 'react';

import { useCreatePayoutAccount } from '@givebacks/api/core';
import { REGEX } from '@givebacks/utils';
import {
  ButtonMantine,
  Center,
  Group,
  ImageMantine,
  Stack,
  Text,
  TextInput,
  notifications,
} from 'ui';
import { matches, useField } from 'ui/Form';
import { svg_venmo } from 'ui/Icons';

const VenmoAccountForm = ({ onClose }: { onClose: () => void }) => {
  const { mutate: connectVenmo, isPending: isLoading } = useCreatePayoutAccount();

  const field = useField({
    initialValue: '',
    validate: matches(REGEX.PHONE_NUMBER_REGEX, 'Phone Number is invalid'),
  });

  const handleConnectAccount = useCallback(async () => {
    const errors = await field.validate();
    if (errors) return;

    connectVenmo(
      {
        accountType: 'venmo',
        request: { venmo_account: { phone_number: field.getValue() } },
      },
      {
        onSuccess: () => {
          notifications.show({
            title: 'Account Connected',
            message: 'Your account has been connected',
            variant: 'success',
          });
          onClose();
        },
        onError: () => {
          notifications.show({
            title: 'Error',
            message: 'There was an error connecting your account',
            variant: 'error',
          });
        },
      }
    );
  }, [connectVenmo, field, onClose]);

  return (
    <Stack>
      <Center>
        <Group gap="xs">
          <Text fz={10}>Secured with</Text>
          <ImageMantine src={svg_venmo} h={22} w="auto" />
        </Group>
      </Center>
      <TextInput {...field.getInputProps()} placeholder="Phone Number associated w/ account" />
      <ButtonMantine onClick={handleConnectAccount} loading={isLoading}>
        Connect Account
      </ButtonMantine>
    </Stack>
  );
};

export { VenmoAccountForm };
